var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_11451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50009 4.16663L5.83343 2.49996M1.04175 8.9583L2.4519 8.80161C2.62419 8.78247 2.71033 8.7729 2.79085 8.74683C2.86229 8.72371 2.93027 8.69103 2.99295 8.6497C3.0636 8.60311 3.12489 8.54182 3.24747 8.41925L8.75009 2.91663C9.21033 2.45639 9.21033 1.7102 8.75009 1.24996C8.28985 0.789726 7.54366 0.789726 7.08343 1.24996L1.5808 6.75258C1.45823 6.87515 1.39694 6.93644 1.35035 7.00709C1.30901 7.06978 1.27634 7.13776 1.25321 7.20919C1.22715 7.28971 1.21757 7.37586 1.19843 7.54815L1.04175 8.9583Z",
    stroke: "#0F2E59",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_11451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.76f851fdb744e4291f9876167ae6a1a8.svg";
export { ForwardRef as ReactComponent };